<!--
  Muestra un icono de la fuente local y hereda el color del texto. Sin size utiliza 1em
  para crecer con la etiqueta que acompaña; size permite fijar una medida cuando sea
  necesario.

  iconName convierte nombres antiguos y proporciona un icono predeterminado para nombres
  inexistentes.
-->
<script lang="ts">
  import { iconClass, iconName } from "@shared/icons";

  import { cx } from "../lib/cx";

  let {
    name,
    size,
    class: className,
    color,
  }: {
    name?: string;
    /** Medida en px. Sin ella, el icono mide lo que el texto que lo rodea. */
    size?: number;
    class?: string;
    color?: string;
  } = $props();
</script>

<i
  aria-hidden="true"
  class={cx(iconClass(iconName(name)), "icon-glyph inline-flex", className)}
  style="{size === undefined ? '' : `font-size: ${size}px;`}{color ? ` color: ${color};` : ''}"
></i>

<style>
  /* Al ser letra hereda `currentColor` y escala con el texto que la rodea: sin
     `size`, `1em` la deja exactamente de la medida de ese texto. Le gana al
     tamaño de partida de `theme.css` (`i.icon`) a propósito; los
     pocos sitios del catálogo que agrandan el icono con dos clases --`.btn.sm i`,
     `.btn-icon.sm i`-- siguen mandando, y son botones sin texto. */
  .icon-glyph {
    line-height: 1;
    font-weight: normal;
  }
</style>
